module.exports = "/_next/static/images/2-e94b5cf011a4850eb55b437e12231501.jpg";